// config.js
const CONFIG = {
  BGG_USERNAME: "ag1320",
};

export default CONFIG;
